class MintSingleton {
  #mint;
  #stateUpdateQueue = [];
  #isReady = false;
  #isDisabled = false;
  #readyPromise;

  constructor() {
    this.#readyPromise = Promise.withResolvers();
  }

  get instance() {
    return this.#mint;
  }

  get isReady() {
    return this.#isReady;
  }

  get readyPromise() {
    return this.#readyPromise?.promise;
  }

  async init(options) {
    this.#mint = await import('@tunein/mint').then((module) => module.default);

    this.#mint.init(options);

    if (this.#stateUpdateQueue.length) {
      this.#stateUpdateQueue.forEach(([key, value]) => {
        this.#mint.updateState(key, value);
      });
    }

    this.#isReady = true;

    this.#readyPromise.resolve();
  }

  updateState(key, value) {
    if (!this.#isReady) {
      this.#stateUpdateQueue.push([key, value]);
      return;
    }

    this.#mint.updateState(key, value);
  }

  disable() {
    if (this.#isDisabled) {
      return;
    }

    this.#readyPromise.resolve();
    this.#isDisabled = true;
  }
}

export const mintSingleton = new MintSingleton();
